import { createContext, useContext } from "react";

export const AuthContext = createContext({
  user: undefined,
  isLoading: false,
  setUser: () => {},
  isSubscribed: false,
  isTrialActive: false,
  trialEndsAt: null,
});

export const useAuthContext = () => useContext(AuthContext);